import { api } from './api';

const getPackagesList = async ({data, pageSize, pageNumber}) => {
    const response = await api({
        url: `Packages/getPagedList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...data
        },
    });
    return response.data;
};

const updatePackages = async (data) => {
    const response = await api({
        url: `Packages/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const packagesServices = {
  getPackagesList,
  updatePackages,
};

export default packagesServices;
